/* Cart upsell (cart page) */
(function cartUpsell() {
  window.MegaMacCart = window.MegaMacCart || {};
  window.MegaMacCart._cartUpsell = window.MegaMacCart._cartUpsell || {};

  const state = window.MegaMacCart._cartUpsell;
  state.drag = state.drag || {
    carousel: null,
    isDown: false,
    startX: 0,
    scrollLeft: 0,
    hasDragged: false,
    dragResetTimer: null,
  };

  const DRAG_THRESHOLD = 5;
  const SCROLL_MULTIPLIER = 1;
  const GAP = 12;

  function getRoot(scope) {
    const s = scope && scope.querySelector ? scope : document;
    return s.querySelector('[data-cart-upsell-root]');
  }

  function setCartUpsellState(root, value) {
    if (!root) return;
    root.setAttribute('data-cart-upsell-state', value);

    const panel = root.closest('[data-cart-shipping-progress-panel]');
    if (panel) panel.setAttribute('data-cart-upsell-state', value);
  }

  function extractTilesFromResponseHtml(text) {
    const html = document.createElement('div');
    html.innerHTML = text;

    const itemsWrapper = html.querySelector(
      '[data-cart-upsell-recommendations-items]',
    );
    if (!itemsWrapper) return [];

    const tiles = itemsWrapper.querySelectorAll('[data-upsell-product-id]');
    return Array.from(tiles);
  }

  async function fetchRecommendationsHtml(
    baseUrl,
    recommendationsSectionId,
    productId,
    intent,
    perProductLimit,
    signal,
  ) {
    const url =
      baseUrl +
      '?section_id=' +
      encodeURIComponent(recommendationsSectionId) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&intent=' +
      encodeURIComponent(intent) +
      '&limit=' +
      encodeURIComponent(perProductLimit);

    const res = await fetch(url, { signal: signal });
    if (!res.ok) return [];
    const text = await res.text();
    return extractTilesFromResponseHtml(text);
  }

  function getCartProductIds(root) {
    const ids = window.MegaMacCart.safeJsonParse(root.dataset.cartProductIds || '[]', []);
    return Array.isArray(ids) ? ids.map(String) : [];
  }

  // Cart products whose recommendations are already on screen (rendered with the page, or fetched since).
  function getFetchedIds(root) {
    const ids = window.MegaMacCart.safeJsonParse(root.dataset.upsellFetchedIds || '[]', []);
    return new Set(Array.isArray(ids) ? ids.map(String) : []);
  }

  function setFetchedIds(root, ids) {
    root.dataset.upsellFetchedIds = JSON.stringify(Array.from(ids));
  }

  function getCards(carousel) {
    return Array.from(carousel.querySelectorAll('[data-upsell-product-id]'));
  }

  // The first card is the one measured for the row width.
  function markFirstCard(carousel) {
    getCards(carousel).forEach(function (card, index) {
      if (index === 0) card.setAttribute('data-cart-upsell-content', '');
      else card.removeAttribute('data-cart-upsell-content');
    });
  }

  // Index of the card at the left edge of the viewport (the one on show on desktop).
  function viewedCardIndex(carousel) {
    const cards = getCards(carousel);
    const left = carousel.scrollLeft;
    let best = 0;
    let bestDistance = Infinity;
    cards.forEach(function (card, index) {
      const distance = Math.abs(card.offsetLeft - left);
      if (distance < bestDistance) {
        best = index;
        bestDistance = distance;
      }
    });
    return best;
  }

  // Lines the viewport up with the start of a card. Cards shift when one is removed, and the scroll
  // position doesn't follow, so the view would otherwise start part-way through a card (Safari doesn't
  // re-snap on its own).
  function scrollToCard(carousel, index) {
    const cards = getCards(carousel);
    if (!cards.length) return;
    const card = cards[Math.max(0, Math.min(index, cards.length - 1))];
    const previous = carousel.style.scrollBehavior;
    carousel.style.scrollBehavior = 'auto';
    carousel.scrollLeft = card.offsetLeft;
    carousel.style.scrollBehavior = previous;
  }

  window.MegaMacCart.scrollCartUpsellToCard = scrollToCard;
  window.MegaMacCart.cartUpsellViewedCardIndex = viewedCardIndex;

  function removeCardsInCart(root, carousel) {
    const inCart = new Set(getCartProductIds(root));
    const viewed = viewedCardIndex(carousel);
    let removed = 0;
    getCards(carousel).forEach(function (card) {
      if (inCart.has(String(card.getAttribute('data-upsell-product-id')))) {
        card.remove();
        removed += 1;
      }
    });
    if (removed) {
      markFirstCard(carousel);
      // The next card takes the removed one's place in view.
      scrollToCard(carousel, viewed);
    }
    return removed;
  }

  // Adds cards to the END of the carousel, so whatever the shopper is looking at stays put. Cards already
  // shown, or for products in the cart, are skipped.
  function appendTiles(root, carousel, tiles, limit) {
    const inCart = new Set(getCartProductIds(root));
    const shown = new Set(
      getCards(carousel).map(function (card) {
        return String(card.getAttribute('data-upsell-product-id'));
      }),
    );
    let added = 0;
    tiles.forEach(function (tile) {
      if (shown.size >= limit) return;
      const id = tile && tile.getAttribute ? String(tile.getAttribute('data-upsell-product-id')) : '';
      if (!id || inCart.has(id) || shown.has(id)) return;
      shown.add(id);
      carousel.appendChild(tile.cloneNode(true));
      added += 1;
    });
    if (added) markFirstCard(carousel);
    return added;
  }

  async function loadCartUpsellRecommendations(root) {
    const carousel = root.querySelector('[data-cart-upsell-carousel]');
    if (!carousel) return;

    root.removeAttribute('data-cart-upsell-refresh');
    removeCardsInCart(root, carousel);

    const cartProductIds = getCartProductIds(root);
    const hasCards = function () {
      return getCards(carousel).length > 0;
    };
    const baseUrl = root.dataset.recommendationsBaseUrl;
    const recommendationsSectionId = root.dataset.upsellRecommendationsSectionId;
    if (parseInt(root.dataset.cartItemCount || '0', 10) <= 0 || !cartProductIds.length || !baseUrl || !recommendationsSectionId) {
      setCartUpsellState(root, hasCards() ? 'loaded' : 'empty');
      return;
    }

    const limit = Math.max(1, parseInt(root.dataset.upsellLimit || '6', 10));
    const maxCartItems = Math.max(1, parseInt(root.dataset.upsellMaxCartItems || '4', 10));

    // Only products whose recommendations aren't on screen yet: all of them on a bare first load, just the
    // newly added ones afterwards.
    const fetched = getFetchedIds(root);
    const targets = cartProductIds
      .filter(function (id) {
        return !fetched.has(id);
      })
      .slice(0, maxCartItems);

    if (!targets.length) {
      setCartUpsellState(root, hasCards() ? 'loaded' : 'empty');
      return;
    }

    // Abort any previous in-flight request (important if cart refreshes quickly).
    if (state.recommendationsController) {
      try {
        state.recommendationsController.abort();
      } catch (_) {}
    }
    const controller = new AbortController();
    state.recommendationsController = controller;
    const signal = controller.signal;

    // All products at once, and each set goes on screen as soon as it arrives.
    await Promise.all(
      targets.map(async function (productId) {
        let tiles = [];
        try {
          tiles = await fetchRecommendationsHtml(
            baseUrl,
            recommendationsSectionId,
            productId,
            'complementary',
            Math.min(10, limit),
            signal,
          );
        } catch (e) {
          if (e && e.name === 'AbortError') return;
        }
        if (signal.aborted) return;
        fetched.add(productId);
        setFetchedIds(root, fetched);
        const added = appendTiles(root, carousel, tiles, limit);
        if (hasCards()) {
          if (root.getAttribute('data-cart-upsell-state') !== 'loaded') setCartUpsellState(root, 'loaded');
          if (added) document.dispatchEvent(new CustomEvent('cart-upsell:loaded'));
        }
      }),
    );

    if (signal.aborted) return;
    if (!hasCards()) setCartUpsellState(root, 'empty');
  }

  function showAllItems(root) {
    const carousel = root.querySelector('[data-cart-upsell-carousel]');
    if (!carousel) return;
    const allExceptFirst = carousel.querySelectorAll(
      '.cart__shipping-progress__upsell__content-wrapper:not(:first-child)',
    );
    allExceptFirst.forEach(function ($item) {
      $item.style.display = 'flex';
    });
  }

  function updateNavVisibility(root) {
    const $btnPrev = root.querySelector('[data-cart-upsell-btn="prev"]');
    const $btnNext = root.querySelector('[data-cart-upsell-btn="next"]');
    const $carousel = root.querySelector('[data-cart-upsell-carousel]');
    if (!$carousel || !$btnPrev || !$btnNext) return;

    const count = $carousel.querySelectorAll(
      '.cart__shipping-progress__upsell__content-wrapper',
    ).length;
    if (!count) return;

    root.setAttribute('data-cart-upsell-count', String(count));
    const hide = count <= 1;

    [$btnPrev, $btnNext].forEach(function (btn) {
      btn.disabled = hide;
      btn.setAttribute('aria-hidden', hide ? 'true' : 'false');
      btn.tabIndex = hide ? -1 : 0;
    });
  }

  function setCarouselWidth(root) {
    const $carousel = root.querySelector('[data-cart-upsell-carousel]');
    if (!$carousel) return;
    const $items = $carousel.querySelectorAll(
      '.cart__shipping-progress__upsell__content-wrapper',
    );
    if ($items.length === 0) return;

    if (window.innerWidth <= 440) {
      $carousel.style.maxWidth = '100%';
      $items.forEach(function ($item) {
        $item.style.width = '100%';
      });
      return;
    }

    $carousel.style.maxWidth = '';
    $items.forEach(function ($item) {
      $item.style.width = '';
    });

    const $firstItem = $carousel.querySelector('[data-cart-upsell-content]');
    if (!$firstItem) return;
    const itemWidth = $firstItem.offsetWidth;
    $carousel.style.maxWidth = `${itemWidth}px`;
  }

  function getCardWidth(root) {
    const $carousel = root.querySelector('[data-cart-upsell-carousel]');
    if (!$carousel) return null;
    const $firstItem = $carousel.querySelector('[data-cart-upsell-content]');
    if (!$firstItem) return null;
    return $firstItem.offsetWidth;
  }

  function getLeftmostVisibleTile(root) {
    const carousel = root.querySelector('[data-cart-upsell-carousel]');
    if (!carousel) return null;

    const tiles = carousel.querySelectorAll(
      '.cart__shipping-progress__upsell__content-wrapper',
    );
    if (!tiles.length) return null;

    const scrollLeftNow = carousel.scrollLeft;
    const viewLeft = scrollLeftNow;
    const viewRight = scrollLeftNow + carousel.clientWidth;
    const carouselRect = carousel.getBoundingClientRect();
    let best = null;
    let bestDistance = Infinity;

    tiles.forEach(function (tile) {
      const tileRect = tile.getBoundingClientRect();
      if (!tileRect.width) return;

      const left = tileRect.left - carouselRect.left + scrollLeftNow;
      const right = left + tileRect.width;
      const isVisible = right > viewLeft + 1 && left < viewRight - 1;
      if (!isVisible) return;

      const distance = Math.abs(left - viewLeft);
      if (distance < bestDistance) {
        best = tile;
        bestDistance = distance;
      }
    });

    return best || tiles[0];
  }

  function updateDesktopButtonState(root) {
    const desktopBtn = root.querySelector(
      '.cart__shipping-progress__upsell__CTA-btn',
    );
    if (!desktopBtn) return;
    // If we're mid-add, force-disable the current (possibly re-rendered) desktop CTA
    // so DOM refreshes can't leave an enabled button in an invalid state.
    if (state.isAdding) {
      desktopBtn.disabled = true;
      desktopBtn.setAttribute('aria-disabled', 'true');
      return;
    }

    const tile = getLeftmostVisibleTile(root);
    if (!tile) {
      desktopBtn.disabled = true;
      desktopBtn.setAttribute('aria-disabled', 'true');
      return;
    }

    const available = tile.getAttribute('data-upsell-available');
    const variantId = tile.getAttribute('data-upsell-variant-id');
    desktopBtn.disabled = available !== 'true' || !variantId;
    if (desktopBtn.disabled) {
      desktopBtn.setAttribute('aria-disabled', 'true');
    } else {
      desktopBtn.removeAttribute('aria-disabled');
    }
  }

  function preventLinkDragBehavior(root) {
    const $carousel = root.querySelector('[data-cart-upsell-carousel]');
    if (!$carousel) return;
    const $links = $carousel.querySelectorAll('a');
    $links.forEach(function ($link) {
      if ($link.dataset.upsellPreventDrag === 'true') return;
      $link.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
      $link.dataset.upsellPreventDrag = 'true';
    });
  }

  function bindDragHandlers(root) {
    const $carousel = root.querySelector('[data-cart-upsell-carousel]');
    if (!$carousel) return;
    if ($carousel.dataset.upsellDragInit === 'true') {
      state.drag.carousel = $carousel;
      return;
    }

    state.drag.carousel = $carousel;
    $carousel.style.cursor = 'grab';

    function startDragging(e) {
      state.drag.isDown = true;
      state.drag.hasDragged = false;
      if (state.drag.dragResetTimer) {
        window.clearTimeout(state.drag.dragResetTimer);
        state.drag.dragResetTimer = null;
      }
      $carousel.style.cursor = 'grabbing';
      state.drag.startX = e.pageX - $carousel.offsetLeft;
      state.drag.scrollLeft = $carousel.scrollLeft;
      e.preventDefault();
    }

    function preventClickAfterDrag(e) {
      if (state.drag.hasDragged && e.detail !== 0) {
        e.preventDefault();
        e.stopPropagation();
      }
      state.drag.hasDragged = false;
      if (state.drag.dragResetTimer) {
        window.clearTimeout(state.drag.dragResetTimer);
        state.drag.dragResetTimer = null;
      }
    }

    preventLinkDragBehavior(root);
    $carousel.addEventListener('mousedown', startDragging);
    $carousel.addEventListener('click', preventClickAfterDrag, true);
    $carousel.dataset.upsellDragInit = 'true';
  }

  // Safari's own smooth scroll is a quick flick over a long distance, and it ignores `behavior: 'auto'`'s
  // fall-through to the CSS `scroll-behavior`, so the wrap from last card to first (or back) is animated by
  // hand there, at the pace Chrome gives for free. Any touch or wheel from the shopper stops it.
  const IS_SAFARI =
    /apple/i.test(navigator.vendor || '') && !/crios|fxios|chrome|android/i.test(navigator.userAgent || '');

  function animateScrollTo(carousel, targetLeft, duration) {
    const startLeft = carousel.scrollLeft;
    const distance = targetLeft - startLeft;
    if (!distance) return;
    if (carousel.__wrapAnimation) carousel.__wrapAnimation.cancel();

    const previousSnap = carousel.style.scrollSnapType;
    const previousBehavior = carousel.style.scrollBehavior;
    carousel.style.scrollSnapType = 'none';
    carousel.style.scrollBehavior = 'auto';
    const start = performance.now();
    let frame = null;
    const stop = function () {
      if (frame) window.cancelAnimationFrame(frame);
      frame = null;
      carousel.style.scrollSnapType = previousSnap;
      carousel.style.scrollBehavior = previousBehavior;
      ['wheel', 'touchstart', 'mousedown'].forEach(function (type) {
        carousel.removeEventListener(type, stop);
      });
      carousel.__wrapAnimation = null;
    };
    const easeInOut = function (t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    };
    const step = function (now) {
      const t = Math.min(1, (now - start) / duration);
      carousel.scrollLeft = startLeft + distance * easeInOut(t);
      if (t < 1) frame = window.requestAnimationFrame(step);
      else stop();
    };
    ['wheel', 'touchstart', 'mousedown'].forEach(function (type) {
      carousel.addEventListener(type, stop, { passive: true });
    });
    carousel.__wrapAnimation = { cancel: stop };
    frame = window.requestAnimationFrame(step);
  }

  window.MegaMacCart.animateCartUpsellScrollTo = animateScrollTo;

  function wrapScrollTo(carousel, left) {
    if (IS_SAFARI) {
      animateScrollTo(carousel, left, 650);
    } else {
      carousel.scrollTo({ left: left, behavior: 'smooth' });
    }
  }

  function bindCarouselNav(root) {
    const $btnPrev = root.querySelector('[data-cart-upsell-btn="prev"]');
    const $btnNext = root.querySelector('[data-cart-upsell-btn="next"]');
    const $carousel = root.querySelector('[data-cart-upsell-carousel]');
    if (!$carousel || !$btnPrev || !$btnNext) return;
    if ($carousel.dataset.upsellNavInit === 'true') return;

    // Step to the real start of the previous/next card. Cards differ in width (titles wrap differently),
    // and stepping by a fixed width drifts; Chrome's scroll-snap hides that, Safari doesn't snap after
    // script-driven scrolls, so the view ended up part-way through a card.
    function scrollPrev() {
      const cards = getCards($carousel);
      if (!cards.length) return;
      const left = $carousel.scrollLeft;
      let target = null;
      cards.forEach(function (card) {
        if (card.offsetLeft < left - 1) target = card;
      });
      if (!target) {
        wrapScrollTo($carousel, $carousel.scrollWidth - $carousel.clientWidth);
        return;
      }
      $carousel.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }

    function scrollNext() {
      const cards = getCards($carousel);
      if (!cards.length) return;
      const left = $carousel.scrollLeft;
      const maxScroll = $carousel.scrollWidth - $carousel.clientWidth;
      const target = cards.find(function (card) {
        return card.offsetLeft > left + 1;
      });
      if (!target || left >= maxScroll - 1) {
        wrapScrollTo($carousel, 0);
        return;
      }
      $carousel.scrollTo({ left: Math.min(target.offsetLeft, maxScroll), behavior: 'smooth' });
    }

    $btnPrev.addEventListener('click', scrollPrev);
    $btnNext.addEventListener('click', scrollNext);
    $carousel.dataset.upsellNavInit = 'true';
  }

  function renderMobileNav(root) {
    const nav = root.querySelector('[data-cart-upsell-mobile-nav]');
    if (!nav) return;
    const carousel = root.querySelector('[data-cart-upsell-carousel]');
    if (!carousel) return;

    const items = carousel.querySelectorAll(
      '.cart__shipping-progress__upsell__content-wrapper',
    );
    nav.innerHTML = '';
    if (items.length <= 1) return;

    for (let i = 0; i < items.length; i++) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cart__shipping-progress__upsell__mobile-nav__btn';
      btn.setAttribute('data-cart-upsell-mobile-nav-index', String(i));
      nav.appendChild(btn);
    }
    // The dots are rebuilt while the shopper may be part-way along (cards appended, fonts loaded), so
    // highlight the card in view rather than the first.
    updateMobileNavActive(root);
  }

  function updateMobileNavActive(root) {
    const nav = root.querySelector('[data-cart-upsell-mobile-nav]');
    if (!nav) return;
    const carousel = root.querySelector('[data-cart-upsell-carousel]');
    if (!carousel) return;

    const items = carousel.querySelectorAll(
      '.cart__shipping-progress__upsell__content-wrapper',
    );
    if (!items.length) return;

    const scrollLeft = carousel.scrollLeft;
    let activeIndex = 0;
    let closestDist = Infinity;

    items.forEach(function (item, idx) {
      const dist = Math.abs(item.offsetLeft - scrollLeft);
      if (dist < closestDist) {
        closestDist = dist;
        activeIndex = idx;
      }
    });

    const btns = nav.querySelectorAll(
      '.cart__shipping-progress__upsell__mobile-nav__btn',
    );
    btns.forEach(function (btn, idx) {
      btn.classList.toggle(
        'cart__shipping-progress__upsell__mobile-nav__btn--active',
        idx === activeIndex,
      );
    });
  }

  function bindMobileNav(root) {
    const nav = root.querySelector('[data-cart-upsell-mobile-nav]');
    const carousel = root.querySelector('[data-cart-upsell-carousel]');
    if (!nav || !carousel) return;
    if (nav.dataset.upsellMobileNavInit === 'true') return;

    nav.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-cart-upsell-mobile-nav-index]');
      if (!btn) return;
      const idx = parseInt(
        btn.getAttribute('data-cart-upsell-mobile-nav-index'),
        10,
      );
      const items = carousel.querySelectorAll(
        '.cart__shipping-progress__upsell__content-wrapper',
      );
      if (!items[idx]) return;
      carousel.scrollTo({
        left: items[idx].offsetLeft,
        behavior: 'smooth',
      });
    });

    carousel.addEventListener('scroll', function () {
      updateMobileNavActive(root);
    });

    nav.dataset.upsellMobileNavInit = 'true';
  }

  function bindAddToCart(root) {
    const carousel = root.querySelector('[data-cart-upsell-carousel]');
    const desktopBtn = root.querySelector(
      '.cart__shipping-progress__upsell__CTA-btn',
    );
    if (!carousel || !desktopBtn) return;
    if (root.dataset.upsellAddInit === 'true') return;

    state.isAdding = state.isAdding || false;
    state.lastScrollAt = state.lastScrollAt || 0;
    state.settleTimer = state.settleTimer || null;
    state.desktopCtaClickTimer = state.desktopCtaClickTimer || null;

    function markScrollActivity() {
      state.lastScrollAt = Date.now();
      if (state.settleTimer) window.clearTimeout(state.settleTimer);
      state.settleTimer = window.setTimeout(function () {
        const currentRoot = getRoot();
        if (currentRoot) updateDesktopButtonState(currentRoot);
      }, 120);
    }

    function addVariantToCart(variantId, buttonsToDisable, thumbUrl) {
      if (!variantId) return;
      if (state.isAdding) return;

      state.isAdding = true;
      try {
        const imageStore =
          window.MegaMacCart &&
          window.MegaMacCart.cartImageStore &&
          typeof window.MegaMacCart.cartImageStore.set === 'function'
            ? window.MegaMacCart.cartImageStore
            : window.MegaMacCart &&
                window.MegaMacCart.hoverImageStore &&
                typeof window.MegaMacCart.hoverImageStore.set === 'function'
              ? window.MegaMacCart.hoverImageStore
              : null;
        if (imageStore && thumbUrl) imageStore.set(variantId, thumbUrl);
      } catch (_) {}
      const btns = Array.isArray(buttonsToDisable) ? buttonsToDisable : [];
      const btnRestore = [];
      btns.forEach(function (b) {
        if (!b) return;
        const originalHtml =
          b.dataset && b.dataset.mmOriginalHtml
            ? b.dataset.mmOriginalHtml
            : b.innerHTML || '';
        if (b.dataset && !b.dataset.mmOriginalHtml)
          b.dataset.mmOriginalHtml = originalHtml;
        btnRestore.push({
          b: b,
          disabled: !!b.disabled,
          ariaDisabled: b.getAttribute('aria-disabled'),
          originalHtml: originalHtml,
        });
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
        // Match product page behavior: show immediate in-flight feedback.
        b.setAttribute('data-mm-adding', 'true');
        b.textContent = 'Adding...';
      });

      const sendAdd = function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
      };
      // Checkout waits for the add (the page's redraw afterwards clears this).
      if (typeof window.MegaMacCart.setCartSummaryPending === 'function') window.MegaMacCart.setCartSummaryPending(true);
      // Through the theme-wide queue, so it can't overlap another cart change (Shopify would lose one).
      (typeof window.MegaMacCart.queueCartRequest === 'function' ? window.MegaMacCart.queueCartRequest(sendAdd) : sendAdd())
        .then(function (res) {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        })
        .then(function (addedItem) {
          if (
            window.MegaMacCart &&
            typeof window.MegaMacCart.dismissUndoForVariant === 'function'
          ) {
            window.MegaMacCart.dismissUndoForVariant(variantId);
          }

          const emitP =
            window.MegaMacCart &&
            typeof window.MegaMacCart.fetchCartAndEmit === 'function'
              ? window.MegaMacCart.fetchCartAndEmit()
              : Promise.resolve();

          if (
            window.MegaMacCart &&
            typeof window.MegaMacCart.refreshNewCartSection === 'function'
          ) {
            return Promise.all([
              emitP,
              window.MegaMacCart.refreshNewCartSection(),
            ])
              .catch(function fallbackToNullCart() {
                return [null];
              })
              .then(function notifyCartItemAdded(results) {
                const cart = results && results[0];
                if (
                  window.MegaMacCart &&
                  typeof window.MegaMacCart.emitCartAdded === 'function'
                ) {
                  window.MegaMacCart.emitCartAdded(
                    cart,
                    addedItem,
                    1,
                    'add',
                    thumbUrl,
                  );
                }
              });
          }

          return Promise.resolve(emitP)
            .catch(function fallbackToNullCart() {
              return null;
            })
            .then(function notifyCartItemAdded(cart) {
              if (
                window.MegaMacCart &&
                typeof window.MegaMacCart.emitCartAdded === 'function'
              ) {
                window.MegaMacCart.emitCartAdded(
                  cart,
                  addedItem,
                  1,
                  'add',
                  thumbUrl,
                );
              }
            });
        })
        .catch(function () {
          // If Ajax fails, fall back to reload to preserve cart correctness.
          window.location.reload();
        })
        .finally(function () {
          state.isAdding = false;
          btnRestore.forEach(function (entry) {
            const b = entry && entry.b;
            if (!b) return;
            // If the cart section was re-rendered, these references can be stale.
            // Only restore state on still-connected elements.
            if (!b.isConnected) return;
            b.disabled = entry.disabled;
            if (entry.ariaDisabled === null) {
              b.removeAttribute('aria-disabled');
            } else {
              b.setAttribute('aria-disabled', entry.ariaDisabled);
            }
            b.innerHTML = entry.originalHtml == null ? '' : entry.originalHtml;
            b.removeAttribute('data-mm-adding');
          });

          // Ensure the *current* desktop CTA (which may have been replaced) is updated.
          const currentRoot = getRoot();
          if (currentRoot) updateDesktopButtonState(currentRoot);
        });
    }

    function handleDesktopCtaClick(clickRoot, clickBtn) {
      if (!clickRoot || !clickBtn) return;
      if (clickBtn.disabled) return;
      if (state.isAdding) return;

      const tile = getLeftmostVisibleTile(clickRoot);
      if (!tile) return;

      const available = tile.getAttribute('data-upsell-available');
      const variantId = tile.getAttribute('data-upsell-variant-id');
      if (available !== 'true' || !variantId) return;

      const img = tile.querySelector('img.cart__shipping-progress__upsell__img');
      const thumbUrl =
        (img && (img.currentSrc || img.getAttribute('src'))) || '';
      addVariantToCart(variantId, [clickBtn], thumbUrl);
    }

    function scheduleDesktopCtaClick() {
      if (state.desktopCtaClickTimer) {
        window.clearTimeout(state.desktopCtaClickTimer);
        state.desktopCtaClickTimer = null;
      }

      state.desktopCtaClickTimer = window.setTimeout(function () {
        state.desktopCtaClickTimer = null;

        const currentRoot = getRoot();
        if (!currentRoot) return;
        const currentBtn = currentRoot.querySelector(
          '.cart__shipping-progress__upsell__CTA-btn',
        );
        if (!currentBtn || !currentBtn.isConnected) return;

        if (Date.now() - state.lastScrollAt < 150) {
          scheduleDesktopCtaClick();
          return;
        }

        handleDesktopCtaClick(currentRoot, currentBtn);
      }, 160);
    }

    desktopBtn.addEventListener('click', function () {
      if (Date.now() - state.lastScrollAt < 150) {
        scheduleDesktopCtaClick();
        return;
      }

      handleDesktopCtaClick(root, desktopBtn);
    });

    root.addEventListener('click', function (event) {
      const btn = event.target.closest(
        '.cart__shipping-progress__upsell__CTA-btn__mobile',
      );
      if (!btn) return;
      if (btn.disabled) return;

      const tile = btn.closest(
        '.cart__shipping-progress__upsell__content-wrapper',
      );
      if (!tile) return;

      const available = tile.getAttribute('data-upsell-available');
      const variantId = tile.getAttribute('data-upsell-variant-id');
      if (available !== 'true' || !variantId) return;

      const img = tile.querySelector('img.cart__shipping-progress__upsell__img');
      const thumbUrl =
        (img && (img.currentSrc || img.getAttribute('src'))) || '';
      addVariantToCart(variantId, [desktopBtn, btn], thumbUrl);
    });

    carousel.addEventListener('scroll', markScrollActivity);
    document.addEventListener('cart-upsell:loaded', function () {
      updateDesktopButtonState(getRoot() || root);
    });

    root.dataset.upsellAddInit = 'true';
  }

  function initCartUpsell() {
    const root = getRoot();
    if (!root) return;

    // Fetch recommendations when the cart section is replaced: from scratch
    // when nothing is shown, or behind the current cards after the cart's
    // products changed.
    if (
      root.getAttribute('data-cart-upsell-state') === 'loading' ||
      root.getAttribute('data-cart-upsell-refresh') === 'true'
    ) {
      loadCartUpsellRecommendations(root);
    }

    showAllItems(root);
    updateNavVisibility(root);
    setCarouselWidth(root);
    // The first set is rendered with the page and measured before web fonts arrive; measure again after.
    if (document.fonts && document.fonts.ready && !state.fontsMeasured) {
      state.fontsMeasured = true;
      document.fonts.ready.then(function () {
        const current = getRoot();
        if (!current) return;
        setCarouselWidth(current);
        updateDesktopButtonState(current);
        renderMobileNav(current);
      });
    }
    bindCarouselNav(root);
    bindDragHandlers(root);
    bindAddToCart(root);
    updateDesktopButtonState(root);
    renderMobileNav(root);
    bindMobileNav(root);
  }

  // Expose so `refreshNewCartSection()` can call it after DOM replacement.
  window.MegaMacCart.initCartUpsell = initCartUpsell;

  // Bind global listeners once (they adapt to whichever carousel is current).
  if (!state._globalsBound) {
    state._globalsBound = true;

    window.addEventListener('resize', function () {
      const root = getRoot();
      if (root) setCarouselWidth(root);
    });

    document.addEventListener('cart-upsell:loaded', function () {
      const root = getRoot();
      if (!root) return;
      preventLinkDragBehavior(root);
      showAllItems(root);
      updateNavVisibility(root);
      setCarouselWidth(root);
      updateDesktopButtonState(root);
      renderMobileNav(root);
      bindMobileNav(root);
    });

    document.addEventListener('mouseup', function () {
      const c = state.drag.carousel;
      if (state.drag.isDown) {
        state.drag.isDown = false;
        if (c) c.style.cursor = 'grab';
        // Line up with the nearest card after a drag; Safari leaves script-driven scrolls where they are.
        if (c && state.drag.hasDragged) {
          const cards = getCards(c);
          if (cards.length) {
            const nearest = cards[viewedCardIndex(c)];
            c.scrollTo({ left: nearest.offsetLeft, behavior: 'smooth' });
          }
        }
      }

      if (state.drag.hasDragged && !state.drag.dragResetTimer) {
        state.drag.dragResetTimer = window.setTimeout(function () {
          state.drag.hasDragged = false;
          state.drag.dragResetTimer = null;
        }, 0);
      }
    });

    document.addEventListener('mousemove', function (e) {
      const c = state.drag.carousel;
      if (!c) return;
      if (!state.drag.isDown) return;
      e.preventDefault();

      const x = e.pageX - c.offsetLeft;
      const walk = (x - state.drag.startX) * SCROLL_MULTIPLIER;
      if (Math.abs(walk) > DRAG_THRESHOLD) state.drag.hasDragged = true;
      c.scrollLeft = state.drag.scrollLeft - walk;
    });

    // Re-init after cart section replacement.
    document.addEventListener('megamac:cart:domrefreshed', function () {
      if (state.desktopCtaClickTimer) {
        window.clearTimeout(state.desktopCtaClickTimer);
        state.desktopCtaClickTimer = null;
      }
      if (state.settleTimer) {
        window.clearTimeout(state.settleTimer);
        state.settleTimer = null;
      }
      initCartUpsell();
    });
  }

  // Initial load.
  initCartUpsell();
})();
